import React from "react";
import { motion } from "framer-motion";
import {
  FiUser,
  FiPhone,
  FiMail,
  FiMapPin,
  FiLinkedin,
  FiFacebook,
  FiInstagram,
} from "react-icons/fi";

export default function Contact() {
  const name = "Martin Rygl";
  const phone = "+420 724 893 865";
  const email = "martin.rygl@4fin.cz";
  const addressTrebic = "Kubišova 1230/51, 674 01 Třebíč 1-Horka-Domky";
  const addressBrno = "Čechyňská 547/5, 602 00 Brno";

  return (
    <section
      id="kontakt"
      className="bg-light px-4 sm:px-6 lg:px-8 py-20 scroll-mt-16"
    >
      <div className="mx-auto mb-16 max-w-3xl text-center">
        <h2 className="mb-4 font-extrabold text-dark text-3xl sm:text-4xl">
          Kontakt
        </h2>
        <p className="text-secondary text-base sm:text-lg leading-relaxed">
          Máte-li zájem o spolupráci, pojďme si domluvit osobní schůzku a
          nezávazně probrat vaše potřeby.
        </p>
      </div>

      <motion.div
        className="relative flex md:flex-row flex-col items-center gap-10 bg-white shadow-md lg:hover:shadow-lg mx-auto p-6 sm:p-8 rounded-2xl max-w-2xl overflow-hidden transition-shadow"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="-top-8 -right-8 absolute bg-primary/20 rounded-full w-20 h-20" />
        <div className="-bottom-8 -left-8 absolute bg-primary/20 rounded-full w-32 h-32" />

        <div className="flex-1 w-full md:text-left text-center">
          <div className="flex justify-center md:justify-start items-center mb-6">
            <FiUser className="mr-4 text-primary text-2xl" />
            <h3 className="font-semibold text-dark text-xl">{name}</h3>
          </div>

          <div className="flex justify-center md:justify-start items-center mb-4">
            <FiPhone className="mr-3 text-primary text-xl" />
            <a
              href={`tel:${phone.replace(/ /g, "")}`}
              className="text-secondary lg:hover:text-primary transition"
            >
              {phone}
            </a>
          </div>

          <div className="flex justify-center md:justify-start items-center mb-6">
            <FiMail className="mr-3 text-primary text-xl" />
            <a
              href={`mailto:${email}`}
              className="text-secondary lg:hover:text-primary transition"
            >
              {email}
            </a>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-center md:justify-start mb-6">
          <div className="flex justify-center md:justify-start items-center mb-6 text-secondary">
            <FiMapPin className="mr-2 text-primary text-xl" />
            <a
              href={`https://www.google.com/maps?q=${encodeURIComponent(addressTrebic)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="lg:hover:text-primary transition "
            >
            Třebíč
            </a>
            <span className="mx-2">|</span>
            <a
              href={`https://www.google.com/maps?q=${encodeURIComponent(addressBrno)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="lg:hover:text-primary transition "
            >
            Brno
            </a>
          </div>
</div>
          <div className="flex justify-center md:justify-start space-x-4 mt-4">
            <a
              href="https://cz.linkedin.com/in/martin-rygl-758736306"
              aria-label="LinkedIn"
              className="z-50 text-secondary md:hover:text-primary transition"
            >
              <FiLinkedin size={24} />
            </a>
            <a
              href="https://www.facebook.com/martin.rygl.3"
              aria-label="Facebook"
              className="z-50 text-secondary md:hover:text-primary transition"
            >
              <FiFacebook size={24} />
            </a>
            <a
              href="https://www.instagram.com/martinrygl98/"
              aria-label="Instagram"
              className="z-50 text-secondary md:hover:text-primary transition"
            >
              <FiInstagram size={24} />
            </a>
          </div>
        </div>

        {/* QR kód se zobrazí jen od tabletů výše (md+) */}
        <div className="hidden md:flex flex-col items-center">
          <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=tel:${encodeURIComponent(
              phone.replace(/ /g, "")
            )}`}
            alt="QR kód pro volání"
            className="mb-2 w-[120px] h-[120px] object-contain"
          />
          <span className="text-secondary text-sm">
            Skenujte pro rychlé volání
          </span>
        </div>
      </motion.div>
    </section>
  );
}
